import React from 'react';
import styled from 'styled-components';
import { navy } from '@zocdoc/branding/colors';

import { Icon } from './_base';

const CheckSVG = styled(Icon).attrs({ viewBox: '0 0 17 15' })`
    width: 1.1333333333em;
`;

const Check = ({ color = navy, ...props }) => (
    <CheckSVG
        data-test="icon-check"
        {...props}
    >
        <polygon
            fill={color}
            points="15.1537251 0 3.05546395 11.03875 3.05546395 7.03625 0.0114675461 7.03625 0 15 3.38420027 15 17 1.81"
        />
    </CheckSVG>
);

export {
    Check as default,
    Check,
};
